import { render, staticRenderFns } from "./app-button.vue?vue&type=template&id=892d294e&scoped=true&"
import script from "./app-button.vue?vue&type=script&lang=js&"
export * from "./app-button.vue?vue&type=script&lang=js&"
import style0 from "./app-button.vue?vue&type=style&index=0&id=892d294e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892d294e",
  null
  
)

export default component.exports